export default __webpack_public_path__ + "static/media/abbeville.8b7481fc.jpg";